import historyEs from '../../views/history/lan/es'
import overviewEs from '../../views/overview/lan/es'


let locales = {};

locales = { ...locales, ...historyEs, ...overviewEs };


export default locales;